import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { handleOnClick } from '../../../../../../utils';
const ActionDropdownItem = ({
  content,
  iconAfter,
  iconBefore,
  isLoading,
  onClick,
  testId
}) => /*#__PURE__*/React.createElement(DropdownItem, {
  elemAfter: iconAfter,
  elemBefore: iconBefore,
  isDisabled: isLoading,
  onClick: handleOnClick(onClick),
  testId: testId
}, content);
export default ActionDropdownItem;